module.exports = __webpack_public_path__ + "img/BCA-payment.a817def4.png";